"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
var ReactVirtualized = _interopRequireWildcard(require("react-virtualized"));
var _ListItem = _interopRequireDefault(require("../ListItem"));
var _Typography = _interopRequireDefault(require("../Typography"));
var _Option = _interopRequireDefault(require("./Option"));
var _constants = require("./constants");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var MenuList = function MenuList(_ref) {
  var _ref$options = _ref.options,
    options = _ref$options === void 0 ? [] : _ref$options,
    _ref$rowHeight = _ref.rowHeight,
    rowHeight = _ref$rowHeight === void 0 ? _constants.ROW_HEIGHT : _ref$rowHeight,
    _ref$groupHeight = _ref.groupHeight,
    groupHeight = _ref$groupHeight === void 0 ? _constants.GROUP_HEIGHT : _ref$groupHeight,
    scrollToIndex = _ref.scrollToIndex,
    width = _ref.width,
    markSelectedOption = _ref.markSelectedOption,
    _ref$noResultsPlaceho = _ref.noResultsPlaceholder,
    noResultsPlaceholder = _ref$noResultsPlaceho === void 0 ? _constants.NO_RECORDS_PLACEHOLDER_DEFAULT : _ref$noResultsPlaceho,
    withSearch = _ref.withSearch;
  var noDataPlaceholder = withSearch ? _constants.NO_DATA_PLACEHOLDER_DEFAULT : noResultsPlaceholder;
  var rowRenderer = (0, _react.useCallback)(function (_ref2) {
    var index = _ref2.index,
      style = _ref2.style;
    var _options$index = options[index],
      render = _options$index.render,
      disabled = _options$index.disabled,
      selected = _options$index.selected,
      focused = _options$index.focused,
      isButton = _options$index.isButton,
      innerProps = _options$index.innerProps,
      type = _options$index.type;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Option["default"], _objectSpread(_objectSpread({
      tabIndex: type === 'option' ? 1000 + index : -1,
      style: style,
      focused: focused,
      disabled: disabled,
      selected: markSelectedOption ? selected : undefined,
      isButton: isButton
    }, innerProps), {}, {
      children: render()
    }), index);
  }, [options, markSelectedOption]);
  var rowHeightGetter = (0, _react.useCallback)(function (_ref3) {
    var index = _ref3.index;
    var type = options[index].type;
    if (type === 'group') {
      return groupHeight;
    } else {
      return rowHeight;
    }
  }, [options, groupHeight, rowHeight]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ReactVirtualized.List, {
    scrollingResetTimeInterval: 0,
    width: width,
    height: (0, _constants.getMinVisibleHeight)(options.length),
    scrollToIndex: scrollToIndex,
    rowCount: options.length,
    rowHeight: rowHeightGetter,
    rowRenderer: rowRenderer,
    tabindex: -1,
    noRowsRenderer: function noRowsRenderer() {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItem["default"], {
        style: {
          height: "".concat(rowHeight, "px")
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography["default"], {
          color: 'textSecondary',
          children: noDataPlaceholder
        })
      });
    }
  });
};
var _default = exports["default"] = MenuList;